import { UPLOAD_FILE_MAX_SIZE_IN_MB } from '#client/components/UploadDocumentsModal/constants/upload';

export const SAME_OLD_PIN_MESSAGE = 'New PIN should not be the same as the current PIN';
export const CONFIRM_PIN_MESSAGE = 'Confirm PIN does not match to New PIN';
export const PIN_NOT_MATCH_MESSAGE = 'PIN does not match.';

export const CVV_ERROR_MESSAGE = 'Invalid CVV code';
export const EXPIRATION_DATE_ERROR_MESSAGE = 'Invalid expiration date';

export const ERROR_MESSAGES = {
  // Upload document
  MAX_SIZE_UPLOAD: (maxSize = UPLOAD_FILE_MAX_SIZE_IN_MB) =>
    `Your file must be ${maxSize} MB or less.`,
  FILE_TYPE_UPLOAD: 'Your file must be a pdf, jpg, jpeg, or png.'
};

export const COMMON_ERROR_MESSAGE_TITLE = 'System error';
export const COMMON_ERROR_MESSAGE_DESC =
  'Dashboard failed to load. Please refresh the page or dismiss to continue banking.';

export const HTTP_REQUEST_TIMEOUT = 'Headers Timeout Error';

export const MFA_REQUIRED_TITLE = 'Two-factor authentication is disabled';
export const MFA_REQUIRED_ERROR = 'We cannot verify your account. Please contact customer support.';

export const PROCESS_APPLICATION_ERROR_MESSAGES = {
  AWAITING_FORMATION: 'awaitingFormation',
  AWAITING_EIN_ORDER_CREATION: 'awaitingEinOrderCreation',
  AWAITING_EIN_ORDER_COMPLETION: 'awaitingEinOrderCompletion',
  AWAITING_EIN: 'awaitingEin',
  APPLICATION_INCOMPLETE: 'applicationIncomplete',
  APPLICATION_NOT_FOUND: 'applicationNotFound',
  APPLICATION_ERROR: 'applicationError',
  APPLICATION_SUBMITTED: 'applicationSubmitted',
  AWAITING_OPERATING_ADDRESS: 'awaitingOperatingAddress'
};
